import { LoyaltyRoutingService } from '../routing'
import { LoyaltyService } from '../services/LoyaltyService'
import { LoyaltySupport } from '../support/LoyaltySupport'

export const useLoyalty = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(LoyaltyService)
    },
    get routing() {
      return alt.get(LoyaltyRoutingService)
    },
    get support() {
      return alt.get(LoyaltySupport)
    },
  }
}
